import React from 'react';

// Context
import {UsuarioContext, UsuarioDispatchContext} from "../../context/UsuarioProvider";

// Router
import {Navigate, NavLink} from 'react-router-dom';

// MUI
import {Button, FormControl, Select, InputLabel, MenuItem, TextField} from "@mui/material";
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

function InventarioPagina() {
    const usuario = React.useContext(UsuarioContext);
    const setUsuario = React.useContext(UsuarioDispatchContext);

    const [ barrio, setBarrio ] = React.useState('');

    return (
        <div>

                <Box sx={{ minWidth: 300, maxWidth:350, marginRight:'auto', marginLeft:'auto' }}>
                    <Card variant="outlined">
                        <CardContent>
                            {!(usuario && usuario.usuario_id) && (
                                <>
                                    <FormControl fullWidth>
                                        <NavLink to="/misionero_ingreso"><Button variant="contained">Menu Principal</Button></NavLink><br /><br />
                                        <TextField label="Aula" variant="outlined" value={"Aula 01"} /><br />
                                        <TextField label="Producto" variant="outlined" value={"Detergente"} /><br />
                                        <TextField label="Cajas de 16 Unidades" variant="outlined" value={"27"} /><br />
                                        <TextField label="Unidades Sueltas" variant="outlined" value={"0"} /><br />
                                        <Button variant="contained">Guardar</Button>
                                    </FormControl>
                                </>
                            )}
                            {usuario && usuario.usuario_id && (
                                <>
                                    <Navigate to="/" />
                                </>
                            )}
                        </CardContent>
                    </Card>
                </Box>
        </div>
    )
}

export default InventarioPagina;